import { action, observable, runInAction } from 'mobx';
import { positionController } from './positionController';
import {
  GetPositionsRequest,
  CreatePositionRequest,
  EditPositionRequest,
} from '../api/positionApi';

// Полная позиция со всем строками
export interface Position {
  id: string,
  name: string,
  shortName: string,
  vendorCode: string,
  description: string,
  classifier1RefId: number,
  classifier1RefName: string,
  classifier2RefId: number,
  classifier2RefName: string,
  createdDate: string,
  deletedDate: string,
  backgroundColor?: string,
  calculatorClassifierRefValueId?: number,
  calculatorClassifierRefValueName?: string,
  runFlatDependent?: boolean,
  executorFeePercent?: number, // Процент вознаграждения исполнителю за услугу
}

// Сокращённая позиция для "выпадашек"
export interface PositionShort {
  id: string,
  name: string,
  shortName: string,
  vendorCode: string,
}

export interface PositionsStore {
  positions: Position[],
  positionsShort: PositionShort[],
  error: any,
  currentPosition: Position,
  showDeleted: boolean, // показывать удалённые позиции в списке
}

export const positionsStore: PositionsStore = observable({
  positions: [],
  positionsShort: [],
  error: null,
  currentPosition: null,
  showDeleted: false,
} as PositionsStore);

export const positionsActions = {
  getPositions: async (request: GetPositionsRequest): Promise<void> => {
    const response = await positionController.getPositions(request);
    positionsActions.handleError(response);
    runInAction(() => {
      positionsStore.positions = response.data;
    });
  },

  getPositionsShort: async (request: GetPositionsRequest): Promise<void> => {
    const response = await positionController.getPositionsShort(request);
    positionsActions.handleError(response);
    runInAction(() => {
      positionsStore.positionsShort = response.data;
    });
  },

  getPositionFromList: async (id: string): Promise<void> => {
    const response = positionsStore.positions.find((v) => v.id === id);
    positionsActions.setCurrentPosition(response || null);
  },

  createPosition: async (request: CreatePositionRequest): Promise<void> => {
    const response = await positionController.createPosition(request);
    positionsActions.handleError(response);
  },

  editPosition: async (id: string, request: EditPositionRequest): Promise<void> => {
    const response = await positionController.editPosition(id, request);
    positionsActions.handleError(response);
    positionsActions.setCurrentPosition(response.data);
  },

  deletePosition: async (id: string): Promise<void> => {
    const response = await positionController.deletePosition(id);
    positionsActions.handleError(response);
  },

  restorePosition: async (id: string): Promise<void> => {
    const response = await positionController.restorePosition(id);
    positionsActions.handleError(response);
  },

  clearCurrentPosition: action(() => {
    positionsStore.currentPosition = null;
  }),

  clearError: action(() => {
    positionsStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      positionsStore.error = errorData;
      throw errorData;
    }
  }),

  setCurrentPosition: action((position: Position) => {
     
    positionsStore.currentPosition = position;
  }),

  setShowDeleted: action(() => {
     
    positionsStore.showDeleted = !positionsStore.showDeleted;
  }),
};
